import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c21ba1de&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=c21ba1de&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21ba1de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c21ba1de')) {
      api.createRecord('c21ba1de', component.options)
    } else {
      api.reload('c21ba1de', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=c21ba1de&scoped=true", function () {
      api.rerender('c21ba1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/adManagement/slideshowManagement/list.vue"
export default component.exports